export default "/images/dfa.avif?f221e8d942967386df45088c7ec0f595";